import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, Divider, Typography } from '@mui/material';

const TopRejectionsTable = ({ rejections }) => {
  const [showAll, setShowAll] = useState(false);
  const [processedRejections, setProcessedRejections] = useState([]);

  useEffect(() => {
    setShowAll(false);
    const errorMap = new Map();

    rejections.forEach(({ errors }) => {
      errors.forEach(({ errorCode, message, count }) => {
        let key = errorCode + message;
        if (!errorMap.has(key)) {
          errorMap.set(key, { errorCode, message, count });
        } else {
          errorMap.get(key).count += count;
        }
      });
    });

    const sortedErrors = Array.from(errorMap.values()).sort((a, b) => b.count - a.count);
    setProcessedRejections(sortedErrors);
  }, [rejections]);

  const displayedRejections = showAll ? processedRejections : processedRejections.slice(0, 5);

  const columns = [
    {
      field: 'errorCode',
      headerName: 'Error Code',
      flex: 0.5,
    },
    {
      field: 'message',
      headerName: 'Error Description',
      flex: 2,
    },
    {
      field: 'count',
      headerName: 'Count',
      flex: 0.3,
    },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ mb: '1.5rem' }}>
        <Typography variant="h6">Top Rejection Reasons</Typography>
        <Divider></Divider>
      </Box>
      <DataGrid
        rows={displayedRejections}
        columns={columns}
        getRowId={(row) => `${row.errorCode}-${row.message}`}
        disableRowSelectionOnClick
        hideFooter
        sortingMode="server"
        sortModel={[{ field: 'count', sort: 'desc' }]}
      />
      {processedRejections.length > 5 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button variant="text" onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show Less' : 'More'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TopRejectionsTable;
